// extracted by mini-css-extract-plugin
export default {"heading":"styles_heading__0XyNX","brand":"styles_brand__aAhI3","link":"styles_link__BqKvq"};